export const statusType = {
    downloading: "downloading",
    loadingMetadata: "loadingMetadata",
    error : "error",
    success: "success",
    extracting: "extracting",
    unstarted: "unstarted"
}